import { FC, ReactNode } from 'react';
import { Provider } from 'react-redux';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

interface GlobalStoreProps {
  children: ReactNode;
}

const GlobalStore: FC<GlobalStoreProps> = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);

export default GlobalStore;
